import React from 'react';
import { Link } from 'react-router-dom';
import './CategoryRow.css'; 

// --- 1. Define your categories with correct links ---
const categories = [
    { 
      label: 'Dresses', 
      slug: 'dresses', 
      img: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Category%2FIMG_8589.webp?alt=media&token=6cbf0037-aeb5-4515-bc93-d8c43a69e878' 
    },
    { 
      label: 'New arrivals', 
      slug: 'new-arrivals', 
      img: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Category%2Fcoord.webp?alt=media&token=e26ffed5-a4f0-4f95-8027-b34df59fe6f3' 
    },
    { 
      label: 'Top wear', 
      slug: 'top-wear', 
      img: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Category%2Ftop.webp?alt=media&token=d44378de-55e1-479b-a40e-b3e1193d32f4' 
    },
    { 
      label: 'Bottom wear', 
      slug: 'bottom-wear', 
      img: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Category%2FIMG_3708.webp?alt=media&token=63378cec-2a49-4982-bcc6-b493e82b95fa' 
    },
    { 
      label: 'Classy indie', 
      slug: 'classy-indie', 
      img: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Category%2FIMG_8693%20(2).webp?alt=media&token=1f6b794b-0d2c-4289-9598-f68ccadeb3d6' 
    },
    // --- ADDED ACCESSORY HERE ---
    { 
      label: 'Accessories', 
      slug: 'accessories', 
      path: '/accessories', // This tells it to use our custom route!
      img: 'https://firebasestorage.googleapis.com/v0/b/chawaltaka-store.firebasestorage.app/o/Photos%2FAcessory.webp?alt=media&token=eb3a29d7-645e-464d-ac02-80718d55d29c' // Replace this empty string with your Firebase image link later
    },
];

const CategoryRow = () => {
  return (
    <section className="category-row" aria-label="Categories">
      <div className="category-inner">
        {categories.map((c, i) => (
          <div className="category-item" key={i}>
            {/* Updated the Link to check for a custom path first */}
            <Link to={c.path || `/category/${c.slug}`} className="category-link" aria-label={c.label}>
              <div className="circle-img">
                {c.img ? (
                  <img src={c.img} alt={c.label}/>
                ) : (
                  // A subtle grey placeholder circle until you upload an image
                  <div style={{width: '100%', height: '100%', backgroundColor: '#f0f0f0', borderRadius: '50%'}}></div>
                )}
              </div>
              <div className="category-label">{c.label}</div>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategoryRow;